var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8576 22.2857H2.57192C1.14906 22.2857 0.000488281 21.1371 0.000488281 19.7142V4.28566C0.000488281 2.8628 1.14906 1.71423 2.57192 1.71423H24.8576C26.2805 1.71423 27.4291 2.8628 27.4291 4.28566V19.7142C27.4291 21.1371 26.2805 22.2857 24.8576 22.2857ZM2.57192 3.42852C2.09192 3.42852 1.71477 3.80566 1.71477 4.28566V19.7142C1.71477 20.1942 2.09192 20.5714 2.57192 20.5714H24.8576C25.3376 20.5714 25.7148 20.1942 25.7148 19.7142V4.28566C25.7148 3.80566 25.3376 3.42852 24.8576 3.42852H2.57192Z",
    fill: "url(#paint0_linear_68_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7148 15.36C12.5148 15.36 11.4176 14.88 10.5948 14.0057L1.59478 4.43998C1.26907 4.09712 1.28621 3.54855 1.62907 3.22283C1.97192 2.89712 2.5205 2.91426 2.84621 3.25712L11.8462 12.8228C12.8234 13.8685 14.6062 13.8685 15.5834 12.8228L24.5834 3.27426C24.9091 2.93141 25.4576 2.91426 25.8005 3.23998C26.1434 3.56569 26.1605 4.11426 25.8348 4.45712L16.8348 14.0228C16.0119 14.8971 14.9148 15.3771 13.7148 15.3771V15.36Z",
    fill: "url(#paint1_linear_68_5)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_68_5",
    x1: 0.000488281,
    y1: 11.9999,
    x2: 27.4291,
    y2: 11.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F966D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#CE68FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#9588FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8297FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_68_5",
    x1: 1.36084,
    y1: 9.18301,
    x2: 26.0687,
    y2: 9.18301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F966D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#CE68FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#9588FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8297FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.43,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.ae15504f3fcae64b7cd21df18d461ef1.svg";
export { ForwardRef as ReactComponent };